<template>
  <section>
    <b-container class="bg-white py-2 my-4 shadow-radius">
      <b-row class="py-2 mb-4">
        <b-col cols="9">
          <b-skeleton width="8rem"></b-skeleton>
        </b-col>
        <b-col cols="3" class="text-right">
          <b-skeleton></b-skeleton>
        </b-col>
      </b-row>
      <b-row v-for="tak in taks" class="align-items-center mb-4">
        <b-col cols="2"  md="1">
          <b-skeleton size="30px"></b-skeleton>
        </b-col>
        <b-col cols="10"  md="11">
          <b-skeleton width="100%" height="45px"></b-skeleton>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      taks: [1, 2, 3],
    };
  },
};
</script>
